import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import api from "../../../../../../api/api";
import { course_bg_image, course_demo_image } from "../../../../../../assets/images/images";
import StudentLessonChatbot from "../../../../../../components/studentLessonChatbot/StudentLessonChatbot";
import { useAuth } from "../../../../../../features/auth/AuthContext";
import DescriptionCoursePopup from "../../teacher/course/DescriptionCoursePopup";
import LessonCard from "./LessonCard";
import BackButton from "../../../../../../components/BackButton/BackButton";
import { useCustomNavigation } from "../../../../../../hooks/useCustomNavigation";
import Pagination from "@mui/material/Pagination";
import { CircularProgress, Fab, Grid, Rating, Tooltip } from "@mui/material";
import Helper from "../../../../../../utils/Helper";
import { toTitleCase } from "../../../../../../utils/utlis";
import { Ring } from "@uiball/loaders";
import CustomTooltip from "../../../../../customtooltip/CustomTooltip";
import { getCompetitiveExamScores, resetgetCompetitiveExamScore } from "../../../../../../state/actions/getCompetativeExamScoreAction";
import FloatingAIButton from "../../../../../../components/FloatingAIButton/FloatingAIButton";
import { setDrawerState, setIsWebAllowed, setQueryMetaData, setAgentData, setInitialProjectId } from "../../../../../../state/reducers/chatDrawerReducers";
import CourseCompletionRatingPopup from "../../../../../../components/CourseCompletionRatingPopup/CourseCompletionRatingPopup";
import RatingPopup from "../../../../../../components/TeacherRatingPopup/TeacherRatingPopup";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LessonCardCompetitive from "./LessonCardComeptitive";
import "./StudentCourseLesson.css";


const getSectionFromName = (lessonName) => {
  const name = lessonName?.toLowerCase() || "";
  if (name.includes("reading") || name.includes("writing")) return "Reading & Writing";
  if (name.includes("math")) return "Math";
  return "General";
};

const getSectionScore = (sectionName, examScores, competitiveExam) => {
  if (competitiveExam === "SAT") {
    const map = {
      "Reading & Writing": examScores?.rw_complete ? `${examScores?.reading_writing}/800` : "—",
      "Math": examScores?.math_complete ? `${examScores?.math}/800` : "—",
    };
    return map[sectionName] ?? "—";
  }
};

const StudentCourseLesson = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const globalState = useSelector((state) => state.globalState);
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);
  const { token } = useAuth();
  const location = useLocation();

  const { id } = useParams();
  const { navigateBackOrDashboard } = useCustomNavigation();
  const [course, setCourse] = useState(location.state?.course || {});
  const [courseId, setCourseId] = useState(
    course?.course_id ?? location.state?.course_id
  );
  const [lessons, setlessondetails] = useState(null);

  const [totalPages, setTotalPages] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const itemsPerPage = 12;
  const [currentPage, setCurrentPage] = useState(1);
  const [courseLoading, setcourseLoading] = useState(false);
  const [lessonLoading, setlessonLoading] = useState(false);
  const examScores = useSelector((state) => state?.getCompetativeExamScore?.examScores);
  const errorMessage = useSelector((state) => state.getCompetativeExamScore.error);
  const [showinvite, setShowInvite] = useState(false); // State to control visibility
  const [showRatingPopup, setShowRatingPopup] = useState(false);
  const [ratingSubmitting, setRatingSubmitting] = useState(false);
  const courseType = course?.course_type;
  const type = course?.type;
  const course_id = course?.course_id;
  const student_id = globalState?.student_details?.data?.student_id;
  const studentOwnRating = course?.student_own_rating
  // const ratingId = course?.course_rating_id || null;
  const [ratingId, setRatingId] = useState(course?.course_rating_id || null);
  const [userRating, setUserRating] = useState(course?.course_rating || null);
  const [showRateCoursePopup, setShowRateCoursePopup] = useState(false);
  const [showCourseRatingTooltip, setShowCourseRatingTooltip] = useState(false);

  const competitiveExam = course?.competitive_exam
  const totalMarks = examScores?.total;
  const readingWritingMarks = examScores?.reading_writing;
  const mathMarks = examScores?.math;
  const englishMarksACT = examScores?.english;
  const mathMarksACT = examScores?.math;
  const readingMarksACT = examScores?.reading;
  const scienceMarksACT = examScores?.science;
  const writingMarksACT = examScores?.writing;
  const totalMarksACT = examScores?.total;

  useEffect(() => {
    localStorage.removeItem("ActiveTab")
    return (() => {
      dispatch(setDrawerState(false));
    });
  }, [])

  const ratingPopupShown = useRef(false);

  useEffect(() => {
    if (course?.completed_in_percentage &&
      course?.show_rating_popup &&
      !(course?.completed_in_percentage === "50%" && course?.rating_popup_shown) &&
      !ratingPopupShown.current) {
      setShowRatingPopup(true);
      ratingPopupShown.current = true;
    }
  }, [course?.completed_in_percentage, course?.show_rating_popup, course?.rating_popup_shown]);

  useEffect(() => {
    setUserRating(course?.course_rating || null);
  }, [course?.course_rating]);

  useEffect(() => {
    if (course?.course_rating_id) {
      setRatingId(course.course_rating_id);
    }
  }, [course?.course_rating_id]);


  const assignmentsCount =
    globalState?.student_details?.data?.my_courses?.pending_assignments;
  const currency_symbol = useSelector((state) => state?.globalState?.currency_symbol);
  const isMarketplace = globalState.enabled_modules?.includes('marketplace');
  // const [userRating, setUserRating] = useState(course?.course_rating || null);
  // const [ratingId, setRatingId] = useState(course?.course_rating_id || null);
  // const [ratingSubmitting, setRatingSubmitting] = useState(false);

  // const handleRatingChange = async (event, newValue) => {
  //   if (!courseId) return;
  //   setUserRating(newValue);
  //   try {
  //     setRatingSubmitting(true);
  //     const payload = {
  //       course: courseId,
  //       rating: newValue,
  //     };
  //     let response;
  //     if (ratingId) {
  //       response = await api.patch(
  //         `rating/course-rating-by-student/${ratingId}/`,
  //         payload,
  //         { headers: { Authorization: `Bearer ${token}` } }
  //       );
  //     } else {
  //       response = await api.post(
  //         `rating/course-rating-by-student/`,
  //         payload,
  //         { headers: { Authorization: `Bearer ${token}` } }
  //       );
  //       if (response?.data?.id) {
  //         setRatingId(response.data.id);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Rating submission failed", error);
  //   } finally {
  //     setRatingSubmitting(false);
  //   }
  // };
  useEffect(() => {
    if (!token) {
      navigate(`/signup?redirect=/course/${id}`);
    }
    else {
      localStorage.removeItem("redirectAfterSignup");
      localStorage.removeItem("redirectToCourse");
    }
  }, [token, id, navigate]);

  useEffect(() => {
    if (id !== "undefined") {
      // Attempt to convert id to a number
      const numericId = Number(id);

      if (isNaN(numericId)) {
        // If id cannot be converted to a number, treat it as a string

        getDecryptCourseId(id);
      } else {
        // If id is a valid number, use it directly

        fetchCourse(numericId);
        fetchLessons(numericId ?? courseId, currentPage);
      }
    }
    else if (
      (courseId !== null && courseId !== "" && typeof courseId === "number") ||
      (id && location.state?.redirected_from === "universal_search")
    ) {
      fetchCourse(id ?? courseId);
      fetchLessons(id ?? courseId, currentPage);
    } else if (token && location.state?.redirected_from !== "universal_search") {
      getDecryptCourseId(id);
    }
  }, [courseId, currentPage, id]);

  const handlePageChange = (event, value) => {
    window.scrollTo(0, 0);
    setCurrentPage(value);
  };
  const inial_value = (currentPage - 1) * itemsPerPage;
  const getDecryptCourseId = async (encrypted_id) => {
    const decrypted_id = await api
      .get(`courses/course-invite/?id=${encrypted_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          return res?.data?.course_id;
        }

        if (res.status === 400) {
          navigate("/dashboard/home");
          return null;
        }
      })
      .catch((err) => {
        navigate("/dashboard/home");
        return null;
      });
    if (!decrypted_id) {
      return;
    }
    await fetchCourse(decrypted_id);
    await fetchLessons(decrypted_id);
    setCourseId(decrypted_id);
  };

  const fetchLessons = (course_id, page) => {
    if (token) {
      setlessonLoading(true);
      api
        .get(`lessons/get-all-lessons/course/${course_id}/`, {
          params: {
            page: page,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`, // `Token ${token}`
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setlessonLoading(false);
            setlessondetails(response?.data?.data ?? []);

            setTotalPages(
              response.data.count >= 12
                ? Math.ceil(response.data.count / itemsPerPage)
                : Math.floor(response.data.count / itemsPerPage)
            ); // Calculate total pages
            setNextUrl(response.data.next); // Update next URL
            setPrevUrl(response.data.previous); // Update previous URL
          }
        })
        .catch((error) => {
          setlessonLoading(false);
          //
        });
    }
  };


  const fetchCourse = async (course_id, showLoader = true) => {
    if (!token) return;

    try {
      if (showLoader) {
        setcourseLoading(true);
      }

      const response = await api.get(
        `courses/get-course/${course_id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const courseData = response.data.data;
        setCourse(courseData);

        if (courseData?.course_id) {
        setCourseId(courseData?.course_id);

      }
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (showLoader) {
        setcourseLoading(false);
      }
    }
  };

  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const [showViewMore, setShowViewMore] = useState(false);

  const paragraphRef = useRef(null);
  const descriptionToggle = () => {
    setDescriptionOpen(!descriptionOpen);
  };

  const AssignmentCard = ({ lesson, assignment }) => {
    const truncate = (str, num) => {
      if (str.length > num) {
        return str.slice(0, num) + "...";
      } else {
        return str;
      }
    };

    return (
      <div className="preview-assignments-inner-folder">
        <ol>
          <li>{truncate(assignment.name, 15)}</li>
        </ol>
        <div className="Created-assignments-date">
          <p className="Created">Created:</p>
          <p>{dayjs(assignment.start_date).format("MMM DD, YYYY")}</p>
        </div>
        <div className="Created-assignments-date Created-assignments-due-date">
          <p className="due-date">Due date:</p>
          <p>{dayjs(assignment.end_date).format("MMM DD, YYYY")}</p>
        </div>
        <div
          className="View-Progress-btn"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          View Progress
        </div>
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          Preview assignment
        </button>
      </div>
    );
  };
  useEffect(() => {
    return () => {
      dispatch(resetgetCompetitiveExamScore()); // clear Redux data
      setlessondetails(null); // clear local state
    };
  }, []);

  const rwCompleted = lessons
    ?.filter((l) => getSectionFromName(l?.name) === "Reading & Writing")
    ?.every((l) => l?.comp_assignment_submission === true) ?? false;

  const mathCompleted = lessons
    ?.filter((l) => getSectionFromName(l?.name) === "Math")
    ?.every((l) => l?.comp_assignment_submission === true) ?? false;


  useEffect(() => {
    const demo = {
      "student_id": student_id,
      "course_id": course_id,
      rw_completed: rwCompleted,
      math_completed: mathCompleted,
    };

    if (course_id && (courseType === 2 || type === 2)) {
      dispatch(getCompetitiveExamScores(demo, token));
    }
  }, [course_id, lessons]);

  useEffect(() => {
    const descriptionLength = course?.description?.length || 0;

    // Show "View More" if description is longer than 150 characters
    // This is a more reasonable threshold for showing the button
    const shouldShowViewMore = descriptionLength > 150;
    setShowViewMore(shouldShowViewMore);

  }, [course?.description]);

  // if (location.state === null && location.state !== "after submission") {
  //   navigate("/dashboard/home");
  //   return;
  // }

  const handleRatingChange = async (event, newValue) => {
    if (!newValue) return;
    setUserRating(newValue);
    try {
      setRatingSubmitting(true);
      const payload = {
        course: courseId,
        student: student_id,
        rating: newValue,
      };

      if (ratingId) {
        await api.put(
          `rating/course-rating-by-student/${ratingId}/`,
          payload,
          { headers: { Authorization: `Token ${token}` } }
        );
      } else {
        const res = await api.post(
          `rating/course-rating-by-student/`,
          payload,
          { headers: { Authorization: `Token ${token}` } }
        );
        if (res?.id) {
          setRatingId(res?.id); // save for subsequent changes in the same session
        }
      }
    } catch (error) {
      console.error("Rating submission failed", error);
    } finally {
      setRatingSubmitting(false);
    }
  };


  return (
    <>
      {!token ?
        <Grid
          height={"50vh"}
          xs={12}
          container
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CircularProgress size={80} />
        </Grid>
        :
        <div id="StudentActiveLesson-section">
          <div className="view-course-Details-wrapper">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  {/* <div className="view-course-Details-back-btn-folder">
                  <BackButton buttonName={"Back"} />
                </div> */}
                  <div className="view-course-Details-back-btn-folder">
                    {(location.state === null || location.state === "after submission") ? (
                      <div className="view-course-Details-back-btn-folder" onClick={() => navigate("/")}>
                        <i class="fa-solid fa-chevron-left"></i>
                        <h2>Back</h2>
                      </div>
                    ) : (
                      <BackButton buttonName={"Back"} goBack={true} />
                    )}
                  </div>

                  {courseLoading || lessonLoading ?  <Grid
                          height={"50vh"}
                          xs={12}
                          container
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <CircularProgress size={80} />
                        </Grid> : 
                        <>
                  <div className="view-course-details-container">
                    <div className="view-course-details-folder student-view-course-Detaails-folder">
                      {/* {courseLoading || lessonLoading ?
                        <Grid
                          height={"50vh"}
                          xs={12}
                          container
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <CircularProgress size={80} />
                        </Grid>
                        : */}
                        <>
                        <div className="view-course-details-left-section">
                          <div className="view-course-details-image">
                            <img
                              src={
                                course?.image_url ||
                                course?.image ||
                                course_demo_image
                              }
                              alt=""
                            />
                          </div>
                        </div>
                          <div className="view-course-details-right-section rating-course-wrapper">
                            {isMarketplace && course?.subject && !competitiveExam && (
                              <h5 style={{ color: "#888888", fontSize: "14px", marginBottom: "4px" }}>
                                {typeof course.subject === 'string'
                                  ? toTitleCase(course.subject)
                                  : toTitleCase(Object.values(course.subject)[0]) || ''}
                              </h5>
                            )}

                            {isMarketplace && course?.subject && (
                              <div className="studentDashboar-Suggested-Courses-profile-rate flex justify-between">
                                <>
                                {!competitiveExam && (
                                <div className="flex gap-2 max-w-[90%]">
                                  <div className = "truncate text-[17px] font-medium max-w-[90%]">
                                      {course?.name}
                                    </div>
                                    
                                    <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                                    <a>
                                      <i className="fa-solid fa-star"></i>
                                    </a>
                                    <p className="rate">{course?.average_course_rating || "0"}</p>
                                    <p className="number">({parseInt(course?.rating_count || 0)})</p>

                                  </div>  
                                </div>
                                  )}
                                </>
                                
                              {!competitiveExam && (
  
                          <div className="studentDashboard-course-name-rating">
                            {isMarketplace && (
                               <div style={{ display: "flex", flexDirection: "column", alignItems: "start", minWidth: "120px" }}>
                                  {/* Label + Info Icon */}
                                  <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                                    <span style={{ fontSize: "13px", fontWeight: 500, color: "#333" }}>
                                      Rate course
                                    </span>
                                    <span
                                      onMouseEnter={() => setShowCourseRatingTooltip(true)}
                                      onMouseLeave={() => setShowCourseRatingTooltip(false)}
                                      style={{ cursor: "pointer", fontSize: "16px", color: "#888", position: "relative" }}
                                    >
                                      <InfoOutlinedIcon
                                        style={{ fontSize: "18px", color: "#0c0c0c", cursor: "pointer", position: "relative" }}
                                      />

                                          {/* Tooltip */}
                                          {showCourseRatingTooltip && (
                                            <div className="course-rating-popup"  style={{
                                              position: "absolute",
                                              top: "28px",
                                              right: "0%",
                                              background: "#fff",
                                              borderRadius: "12px",
                                              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                                              padding: "20px",
                                              width: "280px",
                                              zIndex: 999,
                                              pointerEvents: "none"
                                            }}>
                                              {/* Overall Rating */}
                                              <div style={{ fontSize: "36px", fontWeight: "500", color: "#000", lineHeight: 1 }}>
                                                {course?.average_course_rating ?? "0"}
                                              </div>

                                              {/* Star Icons */}
                                              <div style={{ display: "flex", gap: "4px", margin: "8px 0 4px" }}>
                                                {[1, 2, 3, 4, 5].map((star) => {
                                                  const rating = course?.average_course_rating ?? 0;
                                                  return (
                                                    <i
                                                      key={star}
                                                      className={
                                                        star <= Math.floor(rating)
                                                          ? "fa-solid fa-star"
                                                          : star === Math.ceil(rating) && rating % 1 !== 0
                                                            ? "fa-solid fa-star-half-stroke"
                                                            : "fa-regular fa-star"
                                                      }
                                                      style={{ color: "#f5a623", fontSize: "18px" }}
                                                    />
                                                  );
                                                })}
                                              </div>

                                              {course?.rating_count > 0 && (
                                                <p style={{ fontSize: "12px", color: "#666", margin: "0 0 12px" }}>
                                                  {course.rating_count.toLocaleString()} {course.rating_count === 1 ? "rating" : "ratings"}
                                                </p>
                                              )}

                                              {/* Star Breakdown */}
                                              {(() => {
                                                const breakdown = course?.rating_breakdown ?? {};
                                                const total = Object.values(breakdown).reduce((a, b) => Number(a) + Number(b), 0);
                                                return [5, 4, 3, 2, 1].map((star) => {
                                                  const count = Number(breakdown[`${star}_star`] ?? 0);
                                                  const percent = total > 0 ? (count / total) * 100 : 0;
                                                  return (
                                                    <div key={star} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                                                      <span style={{ fontSize: "13px", color: "#444", minWidth: "40px" }}>{star} Star</span>
                                                      <div style={{ flex: 1, background: "#e0e0e0", borderRadius: "4px", height: "6px" }}>
                                                        <div style={{ width: `${percent}%`, background: "#1a73e8", borderRadius: "4px", height: "100%" }} />
                                                      </div>
                                                      <span style={{ fontSize: "13px", color: "#444", minWidth: "20px", textAlign: "right" }}>
                                                        {String(count).padStart(2, "0")}
                                                      </span>
                                                    </div>
                                                  );
                                                });
                                              })()}
                                            </div>
                                          )}
                                        </span>
                                      </div>

                                  {/* Stars */}
                                  <Rating
                                    name={`course-rating-${courseId}`}
                                    value={studentOwnRating}
                                    onChange={() => setShowRateCoursePopup(true)}
                                    disabled={ratingSubmitting}
                                    size="medium"
                                    sx={{
                                      "& .MuiRating-iconEmpty": { color: "#ccc" },
                                      "& .MuiRating-iconFilled": { color: "#f5a623" },
                                    }}
                                  />
                                </div>
                            )}
                            </div>
                              )}
                            </div>
                            )}

                            {/* 
                            {isMarketplace && (course?.price != null || course?.discounted_price != null || course?.discount_price != null) && (
                              <div className="Price-section" style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                <h5 style={{ margin: 0 }}>Price:</h5>
                                {(course?.discount_price ?? course?.discounted_price) != course?.price && course?.price > 0 && (
                                  <span style={{ textDecoration: "line-through", color: "#888888" }}>
                                    {currency_symbol ?? ""}{course?.price ?? 0}
                                  </span>
                                )}
                                <span className="course-price" style={{ color: "#ee7139", fontSize: "20px", fontWeight: 600 }}>
                                  {currency_symbol ?? ""}{course?.discount_price ?? course?.discounted_price ?? 0}
                                </span>
                              </div>
                            )} */}
                            <div className="flex flex-col gap-3 mb-3 w-max lg:flex-row lg:justify-between lg:w-full">
                              {(!isMarketplace || competitiveExam) &&(
                              <h2>
                                {course?.name}
                              </h2>
                            )}
                            {courseType === 2 && (
                              <div className="flex gap-2 items-center shadow-[0px_0px_8px_0px_#00000029] rounded-[8px] py-[7px] px-[21px]">
                                <span className="font-medium text-[#000000] text-[14px]">Total Score</span>
                                <span className="bg-[#EBF3FF] rounded-[20px] py-[3px] px-[21px] text-[#0068FF] text-[12px] font-medium">
                                  {competitiveExam === "SAT"
                                    ? totalMarks != null ? `${totalMarks}/1600` : "—"
                                    : "—"}
                                </span>
                              </div>
                            )}
                            </div>
                            <div className="teacherviewcoursedetails-des-wrapper" style={{ position: 'relative' }}>
                              <p
                                className="teacherviewcoursedetails-des"
                                ref={paragraphRef}
                                style={{
                                  overflow: showViewMore ? 'hidden' : 'visible',
                                  position: 'relative'
                                }}
                              >
                                {course?.description}
                              </p>
                              {showViewMore && (
                                <span className="view-more" onClick={descriptionToggle}>
                                  View More
                                </span>
                              )}
                              {descriptionOpen && (
                                <DescriptionCoursePopup
                                  title="My Course Description"
                                  data={course?.description}
                                  onClick={descriptionToggle}
                                />
                              )}
                            </div>
                            <div className="view-course-details-container lg:gap-[32px] justify-start">
                              <div className="view-Students-course-details-folder">
                                <span>Total Lessons</span>
                                <div className="view-Students-course-details-counts">
                                  <p>{lessons?.length ?? 0}</p>
                                  <p>{lessons?.length > 1 ? "Lessons" : "Lesson"} </p>
                                </div>
                              </div>
                              <div className="view-Students-course-details-folder">
                                <span>Total Assignments</span>
                                <div className="view-Students-course-details-counts">
                                  <p>{course.total_assignments}</p>
                                  <p>{course.total_assignments > 1 ? "Assignments" : "Assignment"}{" "}</p>
                                </div>
                              </div>
                              <div className="view-Students-course-details-folder">
                                <span>Course Start Date</span>
                                <div className="view-Students-course-details-counts">
                                  <p>
                                    {" "}
                                    {
                                      // Helper.formatDateTime(course?.start_date).date
                                      dayjs(course?.start_date).format("MMM DD, YYYY")
                                    }{" "}
                                  </p>
                                </div>
                              </div>
                              <div className="view-Students-course-details-folder">
                                <span>Course Expiry Date:</span>
                                <div className="view-Students-course-details-counts">
                                  <p>
                                    {course?.end_date
                                      // ? Helper.formatDateTime(course.end_date).date
                                      ? dayjs(course?.end_date).format("MMM DD, YYYY")
                                      : "Date not set"}
                                  </p>
                                </div>
                              </div>
                              {/* {courseType === 2 && <div className="view-Students-course-details-folder">
                                <span>Final Score</span>
                                <div className="view-Students-course-details-counts">
                                    {/* <p onClick={handleResultCLick}>View Result</p> */}
                              {/* <p  onClick={() => setShowInvite(true)} style={{ cursor: 'pointer' }} >View Result</p> */}
                              {/* </div> */}
                              {/* <button type="button" class="btn btn-outline-primary mt-2" onClick={() => setShowInvite(true)} >View Result</button> */}
                              {/* </div> */}

                              {/* {courseType === 2 && <div className="view-Students-course-details-folder">
                                <span>Final Score</span>
                                {/* <div className="view-Students-course-details-counts"> */}
                              {/* <p onClick={handleResultCLick}>View Result</p> */}
                              {/* <p  onClick={() => setShowInvite(true)} style={{ cursor: 'pointer' }} >View Result</p> */}
                              {/* </div> */}
                              {/* <button type="button" class="maltiple-assignment-btn" onClick={() => setShowInvite(true)} >View Result</button> */}
                              {/* </div>} */}

                              {/* {courseType === 2 && (
                                <div className="view-Students-course-details-folder">
                                  <span>Final Score</span> */}

                              {/* Tooltip display based on errorMessage */}
                              {/* {errorMessage && (
                                    <Tooltip title={errorMessage} arrow>
                                      <button
                                        type="button"
                                        className="maltiple-assignment-btn"
                                        onClick={() => setShowInvite(false)} // Make sure to set showInvite to false
                                        disabled={true} // Optionally disable the button if errorMessage is present
                                      >
                                        View Result
                                      </button>
                                    </Tooltip>
                                  )} */}

                              {/* Button when no error message is present */}
                              {/* {!errorMessage && (
                                    <button
                                      type="button"
                                      className="maltiple-assignment-btn"
                                      onClick={() => setShowInvite(true)}
                                    >
                                      View Result
                                    </button>
                                  )}
                                </div>
                              )} */}

                            </div>
                          </div>
                        </>
                         {/* } */}
                    </div>
                  </div>
                  <div className="Student-Active-Lesson-container mt-4">
                    {lessonLoading ? (
                      <></>
                    ) : lessons?.length > 0 ? (
                      (courseType === 2 || type === 2) ? (
                        (() => {
                          const grouped = lessons.reduce((acc, lesson) => {
                            const section = getSectionFromName(lesson?.name);  // ← use name-based grouping
                            if (!acc[section]) acc[section] = [];
                            acc[section].push(lesson);
                            return acc;
                          }, {});

                              return Object.entries(grouped).map(([sectionName, sectionLessons]) => (
                                <div key={sectionName} className="competitive-section-group shadow-[0px_0px_8px_0px_#00000029] rounded-[8px] p-[0.8rem] md:p-4 mt-3 mb-3">
                                  <div className="competitive-section-header flex items-center justify-between">
                                    <h4 className="font-medium">{sectionName}</h4>
                                    <span className="competitive-section-score font-medium text-[16px]">
                                      Score{" "}
                                       <span className={getSectionScore(sectionName, examScores, course?.competitive_exam) !== "—" ? "competitive-score-value bg-[#EBF3FF] rounded-[20px] py-[3px] px-[21px] text-[#0068FF] text-[12px]" : "bg-[#EBF3FF] rounded-[20px] py-[3px] px-[21px] text-[#0068FF] text-[12px]"} >
                                        {getSectionScore(sectionName, examScores, course?.competitive_exam)}
                                      </span>
                                    </span>
                                  </div>

                              {sectionLessons.map((lesson, idx) => (
                                <LessonCardCompetitive
                                  key={lesson.lesson_id}
                                  lesson={lesson}
                                  index={lessons.indexOf(lesson)}
                                  course={course}
                                  courseId={courseId}
                                  inial_value={inial_value}
                                  lessons={lessons}
                                  isLocked={idx > 0 && !sectionLessons[idx - 1]?.comp_assignment_submission}
                                />
                              ))}
                            </div>
                          ));
                        })()
                      ) : (
                        lessons.map((lesson, index) => (
                          <LessonCard
                            key={index}
                            lesson={lesson}
                            index={index}
                            course={course}
                            courseId={courseId}
                            inial_value={inial_value}
                            lessons={lessons}
                          />
                        ))
                      )
                    ) : (
                      <p className="no-lessons-available">No lessons available.</p>
                    )}
                  { totalPages > 1 && (
                    <Grid xs={12} container justifyContent={"center"}>
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={
                          nextUrl === null || currentPage === totalPages
                        } // Disable if no next URL and on the last page
                        hidePrevButton={prevUrl === null || currentPage === 1} // Hide if no previous URL and on the first page
                      />
                    </Grid>)
}
                  </div>
                        </>
                         }

                  <div>
                    <FloatingAIButton
                      onClick={() => {
                        // Create agentData with "General AI" and current course
                        const agentData = [
                          {
                            key: course?.name || "Course",
                            value: String(course_id || ""),
                          },
                        ];

                        dispatch(setAgentData(agentData));
                        // Set initial project ID to the current course
                        if (course_id) {
                          dispatch(setInitialProjectId(String(course_id)));
                        }
                        dispatch(setDrawerState(!chatDrawerState.isOpen));
                        dispatch(setIsWebAllowed(true));
                        dispatch(setQueryMetaData(null));
                      }}
                    />
                  </div>
                </div>
                {/* {showinvite && <div className="view-course-details-share-form">
                    <div className="view-course-details-share-folder">
                      <h2>Final Score</h2>
                      <div className="view-course-details-inner-wrapper">
                        <div className="box-folder">
                            <div className="box-1">
                                <span>Total</span>
                                <p>{totalMarks}</p>
                            </div>
                            <div className="box-1">
                                <span>Current Percentile</span>
                                <p>{CurrentPercentile}</p>
                            </div>
                            <div className="box-1">
                                <span>Reading writing</span>
                                <p>{readingWritingMarks}</p>
                            </div>
                            <div className="box-1">
                                <span>Math</span>
                                <p>{mathMarks}</p>
                            </div>
                        </div>

                        <i
                          onClick={() => setShowInvite(false)}
                          data-aos="zoom-in"
                          className="fa-solid fa-xmark shocial-cross-btn invite-student-close-btn"
                        ></i>
                      </div>
                    </div>
                  </div>} */}

                {course?.completed_in_percentage &&
                  course?.show_rating_popup &&
                  !competitiveExam &&  
                  !(course?.completed_in_percentage === "50%" && course?.rating_popup_shown) &&
                  (
                    <CourseCompletionRatingPopup
                      open={showRatingPopup}
                      onClose={() => {
                        setShowRatingPopup(false);
                        fetchCourse(courseId || course?.course_id, false);
                      }}
                      courseName={course?.name}
                      teacherName={course?.teacher}
                      courseId={course?.course_id}
                      token={token}
                      completionStatus={course?.completed_in_percentage}
                      isAlreadyRated={false}
                      teacher_rating={course?.teacher_rating}
                      course_rating={course?.course_rating}
                      studentId={student_id}
                      ratingId={ratingId}
                      onRatingIdUpdate={(newId) => setRatingId(newId)}
                      teacherId={course?.teacher_id}
                      teacher_rating_id={course?.teacher_rating_id}
                    />
                  )}

                {
                  showRateCoursePopup && !competitiveExam && (
                    <RatingPopup
                      type="course"
                      name={course?.name}
                      entityId={courseId}
                      studentId={student_id}
                      token={token}
                      ratingId={ratingId}
                      hasRated={!!ratingId}
                      initialRating={studentOwnRating}
                      onRatingIdUpdate={(newId) => setRatingId(newId)}
                      onClose={() => {
                        setShowRateCoursePopup(false);
                        fetchCourse(courseId || course?.course_id, false);  // refresh to update displayed rating
                      }}
                    />
                  )
                }

                {
                  showinvite && (
                    <div className="view-course-details-share-form">
                      <div className="view-course-details-share-folder">
                        <h2 className="final-score-title">Final Score</h2>
                        <i
                          onClick={() => setShowInvite(false)}
                          className="fa-solid fa-xmark close-btn"
                        ></i>
                        <div className="view-course-details-inner-wrapper">
                          <div className="box-folder">
                            {competitiveExam === "SAT" ? (
                              <>
                                {/* SAT: 3 boxes */}
                                <div className="box-1">
                                  <span>Total</span>
                                  <p>{totalMarks}/1600</p>
                                </div>
                                <div className="box-2">
                                  <span>Reading & Writing</span>
                                  <p>{readingWritingMarks}/800</p>
                                </div>
                                <div className="box-2">
                                  <span>Math</span>
                                  <p>{mathMarks}/800</p>
                                </div>
                              </>
                            ) : competitiveExam === "ACT" ? (
                              <>
                                {/* ACT: 6 boxes */}
                                <div className="box-2">
                                  <span>Total</span>
                                  <p>{totalMarksACT}/36</p>
                                </div>
                                <div className="box-2">
                                  <span>English</span>
                                  <p>{englishMarksACT}/36</p>
                                </div>
                                <div className="box-2">
                                  <span>Math</span>
                                  <p>{mathMarksACT}/36</p>
                                </div>
                                <div className="box-2">
                                  <span>Reading</span>
                                  <p>{readingMarksACT}/36</p>
                                </div>
                                <div className="box-2">
                                  <span>Science</span>
                                  <p>{scienceMarksACT}/36</p>
                                </div>
                                <div className="box-2">
                                  <span>Writing</span>
                                  <p>{writingMarksACT}/36</p>
                                </div>
                              </>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }
              </div >
            </div >
          </div >
        </div >}
    </>
  );
};

export default StudentCourseLesson;